/**
 * /hr/offboarding/letters/$id/acknowledge — recipient letter page (G4.7).
 *
 * Kept for links already sent before wave 2; the body lives in
 * <LetterRecipientView/> (the canonical page is /me/letters/$id, where
 * new letter notifications point).
 */

import { createFileRoute } from "@tanstack/react-router";
import { LetterRecipientView } from "@/components/offboarding/letter-recipient-view";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hr/offboarding/letters/$id/acknowledge",
)({
  component: AcknowledgeLetterRoute,
});

function AcknowledgeLetterRoute() {
  const { id } = Route.useParams();
  return <LetterRecipientView letterId={id} />;
}
